import React, { useContext, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Box } from "@mui/material";
import VerticalDivider from "../components/divider/VerticalDivider";

import SaveIcon from "@mui/icons-material/Save";
import HistoryIcon from "@mui/icons-material/History";
import { Tab, Tabs, Typography } from "@mui/material";
import { itemIcons } from "../components/SideItems/SideItems";

import ProjectContext from "../contexts/ProjectContext";
import FormContext from "../contexts/FormContext";
import SettingsSidebar from "../components/settings/SettingsSidebar";
import SettingsComponent from "../components/settings/SettingsComponent";

import ControlBar from "../components/structure/ControlBar";
import ControlDivider from "../components/structure/ControlDivider";
import SaveButton from "../components/buttons/SaveButton";
import {useFetch} from '../components/auth/useFetch';

export default function KonsolConfigView(props) {
    const viewname = "Konsol Config";

    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);
    const { setHasUnsavedChanges } = useContext(FormContext);

    const [konsolConfig, setKonsolConfig] = useState({});
    const [konsolConfigLabel, setKonsolConfigLabel] = useState({});
    const [originalKonsolConfig, setOriginalKonsolConfig] = useState({});

    //Status Bar Variables
    const [submitStatus, setSubmitStatus] = useState("\u00A0");
    const [submitStatusColor, setSubmitStatusColor] = useState("black");
    const [formState, setFormState] = useState("none");
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const fetchWithAuth = useFetch()

    useEffect(() => {
        if ( formState !== 'unsaved' ) return;

        const handelBeforeUnload = (event) => {
            const message = "You have unsaved changes, Are you sure you want to leave?"
            event.preventDefault();
            event.returnValue = message;
            return message;
        }

        window.addEventListener('beforeunload', handelBeforeUnload, { capture: true })

        return () => {
            window.removeEventListener('beforeunload', handelBeforeUnload, { capture: true })
        };
    }, [formState])

    useEffect(() => {
        setHasUnsavedChanges(formState === 'unsaved');
    }, [formState, setHasUnsavedChanges]);

    useEffect(() => {
        isAuthenticated &&
            (() => {
                loadKonsolConfig();
            })();
    }, [isAuthenticated]);

    useEffect(() => {
        // if (formState == 'error'){
        //     setSaveButtonDisabled(false)
        //     setSubmitStatusColor('red')
        //     let error_message_list = []
        //     for (let item in formError){
        //         error_message_list.push(`${formError[item]}\n`)
        //     }
        //     let error_list_string = error_message_list.toString('')
        //     setSubmitStatus(`Errors have occurred. Changes have not been saved.`)
        //     setFormErrorList(error_list_string)
        // }
        if (formState === "unsaved") {
            setSaveButtonDisabled(false);
            setSubmitStatusColor("orange");
            setSubmitStatus("Unsaved");
        }
        if (formState === "saving") {
            setSaveButtonDisabled(true);
            setSubmitStatus("Saving");
        }
        if (formState === "saved") {
            // const lastSaved = new Date().toLocaleTimeString();
            setSaveButtonDisabled(true);
            setSubmitStatusColor("rgb(0,255,0)");
            setSubmitStatus(`SAVED!`);
            // setSubmitStatus(`SAVED! (${lastSaved})`)
        }
        if (formState === "none") {
            setSaveButtonDisabled(true);
            setSubmitStatusColor("orange");
            setSubmitStatus("\u00A0");
        }
    }, [formState]);

    async function loadKonsolConfig(){
        await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/konsolconfig/meta`, {
            headers:{
                'X-Project-ID': projectContext?.project_db
            },
        })
            .then((res) => res.json())
            .then((result) => setKonsolConfigLabel({...result}))
            .catch(e => {
                console.error(e);
            })

        await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/konsolconfig`, {
            headers:{
                'X-Project-ID': projectContext?.project_db
            },
        })
            .then((res) => res.json())
            .then(
                (result) => {
                    setKonsolConfig({ ...result });
                    setOriginalKonsolConfig({ ...result });
                },
            )
            .catch(e => {
                console.error(e);
            })
    }

    const saveKonsolConfig = () => {
        setFormState("saving");
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("X-Project-ID", projectContext?.project_db);
        var raw = JSON.stringify(konsolConfig);
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: 'follow',
        };
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/konsolconfig/`, requestOptions)
          .then(response => response.text())
          .then(result => {
            setFormState('saved')
          })
          .then(() => {
            setOriginalKonsolConfig(prevData => ({ ...prevData, ...konsolConfig }))
          })
          .catch(e => {
                console.error(e)
                setFormState('error')
          })
    }

    const revertKonsolConfig = () => {
        setKonsolConfig((prevData) => ({ ...prevData, ...originalKonsolConfig }));
        setFormState("none");
        setSubmitStatus("\u00A0");
        setSubmitStatusColor("orange");
    };

    const handleKonsolConfigChange = (newData) => {
        setKonsolConfig((prevData) => ({ ...prevData, ...newData }));
        setFormState("unsaved");
    };

    return (
        <React.Fragment>
            <Box 
                display="flex" 
                flexDirection="column" 
                height='100%'
                width='100%'
                overflow='hidden'
            >
                <Box
                    width='100%'
                >
                    <ControlBar>
                        <Tabs
                            value={0}
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab
                                label={
                                    <Box display="flex" alignItems="center">
                                        {itemIcons[viewname]}
                                        <Box ml={1}>{viewname}</Box>
                                    </Box>
                                }
                                style={{
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    color: "white",
                                }}
                            />
                        </Tabs>

                        <ControlDivider />

                        <Box display="flex" alignItems="center">
                            <SaveButton
                                title="Save"
                                clicked={saveKonsolConfig}
                                disabled={saveButtonDisabled}
                                status={submitStatus}
                                statusColor={submitStatusColor}
                            >
                                <SaveIcon style={{ color: "white" }} />
                            </SaveButton>

                            <SaveButton
                                title="Revert"
                                clicked={revertKonsolConfig}
                                disabled={saveButtonDisabled}
                            >
                                <HistoryIcon style={{ color: "red" }} />
                            </SaveButton>
                        </Box>
                    </ControlBar>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    height='calc(100% - 47px)'
                    width='100%'
                >
                    <Box
                        display={{
                            xs: 'none',
                            sm: 'flex'
                        }}
                        height='100%'
                        minWidth={{
                            sm: '300px'
                        }}
                        maxWidth={{
                            sm: '300px'
                        }}
                        bgcolor='rgba(0,0,0,0.9)'
                        overflow={'auto'}
                    >
                        <SettingsSidebar
                            data={konsolConfig}
                            label={konsolConfigLabel}
                        />
                    </Box>
                    <VerticalDivider />
                    <Box
                        ml={{
                            xs: 0,
                            sm: 0.5
                        }}
                        pl={1}
                        height="100%"
                        width={{
                            xs: '100%',
                            sm: 'calc(100% - 300px)'
                        }}
                        bgcolor='rgba(0,0,0,0.9)'
                        sx={{
                            overflowY: "scroll",
                        }}
                    >
                        <SettingsComponent
                            data={konsolConfig}
                            label={konsolConfigLabel}
                            onChange={handleKonsolConfigChange}
                        />
                    </Box>
                </Box>
            </Box>
        </React.Fragment>
    );
}
